const VERSION = '3.10.0';
export default VERSION;
